import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

@Injectable({
    providedIn: 'root'
})
export class MarkingSettingsValidator {

    apikey = [
        Validators.required
    ];

    // Error messages
    errorMessages = {

        apikey: [
            {
                type: 'required',
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ]
    }
}